import { swup }        from './modules/transitions.js';
import './modules/intro.js';
// import './modules/cursor.js';
import './modules/nav.js';
import { init as initSearch  } from './modules/search.js';
import { init as initSearchDemo } from './modules/search-demo.js';
import { init as initGallery } from './modules/gallery-animate-zoom.js';
import { init as initWall               } from './modules/wall-gallery.js';
import { init as initVideos             } from './modules/videos.js';
import { removeFilterUI } from './modules/filter-ui.js';
import { initStressTour } from './modules/stress-tour.js';
import { init as initPageMedia } from './modules/page-media.js';

// Mobile-friendly in-page DevTools (Console / Network / Elements / etc.)
// Loads only when ?debug=1 is in the URL. Catches all errors, including ones
// that fire before user interaction. Use on iPhone to capture what's actually
// happening (JS errors, console.warn from gallery, network activity).
if (new URLSearchParams(location.search).has('debug')) {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/eruda';
    s.onload = () => { window.eruda?.init(); };
    document.head.appendChild(s);
}

function initAll() {
    initPageMedia();
    removeFilterUI(); // clear any leftover filter launcher/popout from the previous page
    initSearch();
    initSearchDemo();
    initGallery();
    initWall();
    initVideos();
}

// First load
initAll();

// Gallery stress-test protocol (?stress=1, &stressauto=1 to start immediately).
// One tap on a real iPhone; driven headlessly by tests/worldview.spec.js.
initStressTour();

// Re-init after every swup page swap
swup.hooks.on('page:view', initAll);
